export default "__VITE_ASSET___UrDIYfx__"